import { Col, Row } from 'antd';
import 'styles/sass/incidences.scss';

interface IncidenceCategoryPreviewProps {
  text: string;
  bgColor: string;
  txtColor: string;
  className?: string;
  showText?: boolean;
}

export const IncidenceCategoryPreview = ({
  text,
  bgColor,
  txtColor,
  className = '',
  showText = true,
}: IncidenceCategoryPreviewProps) => {
  return (
    <div id="incidence-category-preview" className={className}>
      <Row
        align="middle"
        justify="center"
        className="container"
        style={{ backgroundColor: bgColor }}
      >
        {showText && (
          <Col xs={24}>
            <p style={{ color: txtColor }}>{text}</p>
          </Col>
        )}
      </Row>
    </div>
  );
};
